import { type FormEvent, useState } from 'react'

import { Button, TextField } from '@/components/ui'
import { useToast } from '@/hooks'
import { useAccount, useAccountStore } from '@/modules/account'

export const FirmNameForm = () => {
  const account = useAccount()
  const { updateAccount } = useAccountStore((s) => s.mutations)
  const mutating = useAccountStore((s) => s.mutating)
  const { successToast, errorToast } = useToast()

  const [name, setName] = useState(account?.name ?? '')
  const [error, setError] = useState('')

  const validate = () => {
    const trimmed = name.trim()
    if (!trimmed) {
      setError('Firm name is required')
      return false
    }
    if (trimmed.length > 100) {
      setError('Firm name must be 100 characters or less')
      return false
    }
    setError('')
    return true
  }

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault()
    if (!validate() || !account) return

    updateAccount({ name: name.trim() })
      .then(() => successToast('Firm name updated'))
      .catch((error) =>
        errorToast('Failed to update firm name', error as Error),
      )
  }

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        label="Firm Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        error={error}
        maxLength={100}
        required
      />
      <div className="mt-4 flex justify-end">
        <Button type="submit" isLoading={mutating} loadingText="Saving...">
          Save
        </Button>
      </div>
    </form>
  )
}
